import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Bluetooth(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { fillRule: "evenodd", d: "M11.62.08a1 1 0 0 1 1.09.21l5.5 5.5a1 1 0 0 1 0 1.42L13.4 12l4.8 4.8a1 1 0 0 1 0 1.4l-5.5 5.5A1 1 0 0 1 11 23v-8.59l-3.8 3.8a1 1 0 1 1-1.4-1.42L10.58 12l-4.8-4.8a1 1 0 0 1 1.42-1.4L11 9.58V1a1 1 0 0 1 .62-.92ZM13 14.4l3.09 3.09L13 20.59V14.4Zm0-4.82V3.4l3.09 3.09L13 9.59Z" }) }));
}
